export const countryListData = [
  { code: "AF", value: "AFG", name: "Afghanistan", number: "004" },
  { code: "AL", value: "ALB", name: "Albania", number: "008" },
  { code: "DZ", value: "DZA", name: "Algeria", number: "012" },
  { code: "AS", value: "ASM", name: "American Samoa", number: "016" },
  { code: "AD", value: "AND", name: "Andorra", number: "020" },
  { code: "AO", value: "AGO", name: "Angola", number: "024" },
  { code: "AI", value: "AIA", name: "Anguilla", number: "660" },
  { code: "AQ", value: "ATA", name: "Antarctica", number: "010" },
  { code: "AG", value: "ATG", name: "Antigua and Barbuda", number: "028" },
  { code: "AR", value: "ARG", name: "Argentina", number: "032" },
  { code: "AM", value: "ARM", name: "Armenia", number: "051" },
  { code: "AW", value: "ABW", name: "Aruba", number: "533" },
  { code: "AU", value: "AUS", name: "Australia", number: "036" },
  { code: "AT", value: "AUT", name: "Austria", number: "040" },
  { code: "AZ", value: "AZE", name: "Azerbaijan", number: "031" },
  { code: "BS", value: "BHS", name: "Bahamas (the)", number: "044" },
  { code: "BH", value: "BHR", name: "Bahrain", number: "048" },
  { code: "BD", value: "BGD", name: "Bangladesh", number: "050" },
  { code: "BB", value: "BRB", name: "Barbados", number: "052" },
  { code: "BY", value: "BLR", name: "Belarus", number: "112" },
  { code: "BE", value: "BEL", name: "Belgium", number: "056" },
  { code: "BZ", value: "BLZ", name: "Belize", number: "084" },
  { code: "BJ", value: "BEN", name: "Benin", number: "204" },
  { code: "BM", value: "BMU", name: "Bermuda", number: "060" },
  { code: "BT", value: "BTN", name: "Bhutan", number: "064" },
  {
    code: "BO",
    value: "BOL",
    name: "Bolivia (Plurinational State of)",
    number: "068",
  },
  {
    code: "BQ",
    value: "BES",
    name: "Bonaire, Sint Eustatius and Saba",
    number: "535",
  },
  { code: "BA", value: "BIH", name: "Bosnia and Herzegovina", number: "070" },
  { code: "BW", value: "BWA", name: "Botswana", number: "072" },
  { code: "BV", value: "BVT", name: "Bouvet Island", number: "074" },
  { code: "BR", value: "BRA", name: "Brazil", number: "076" },
  {
    code: "IO",
    value: "IOT",
    name: "British Indian Ocean Territory (the)",
    number: "086",
  },
  { code: "BN", value: "BRN", name: "Brunei Darussalam", number: "096" },
  { code: "BG", value: "BGR", name: "Bulgaria", number: "100" },
  { code: "BF", value: "BFA", name: "Burkina Faso", number: "854" },
  { code: "BI", value: "BDI", name: "Burundi", number: "108" },
  { code: "CV", value: "CPV", name: "Cabo Verde", number: "132" },
  { code: "KH", value: "KHM", name: "Cambodia", number: "116" },
  { code: "CM", value: "CMR", name: "Cameroon", number: "120" },
  { code: "CA", value: "CAN", name: "Canada", number: "124" },
  { code: "KY", value: "CYM", name: "Cayman Islands (the)", number: "136" },
  {
    code: "CF",
    value: "CAF",
    name: "Central African Republic (the)",
    number: "140",
  },
  { code: "TD", value: "TCD", name: "Chad", number: "148" },
  { code: "CL", value: "CHL", name: "Chile", number: "152" },
  { code: "CN", value: "CHN", name: "China", number: "156" },
  { code: "CX", value: "CXR", name: "Christmas Island", number: "162" },
  {
    code: "CC",
    value: "CCK",
    name: "Cocos (Keeling) Islands (the)",
    number: "166",
  },
  { code: "CO", value: "COL", name: "Colombia", number: "170" },
  { code: "KM", value: "COM", name: "Comoros (the)", number: "174" },
  {
    code: "CD",
    value: "COD",
    name: "Congo (the Democratic Republic of the)",
    number: "180",
  },
  { code: "CG", value: "COG", name: "Congo (the)", number: "178" },
  { code: "CK", value: "COK", name: "Cook Islands (the)", number: "184" },
  { code: "CR", value: "CRI", name: "Costa Rica", number: "188" },
  { code: "HR", value: "HRV", name: "Croatia", number: "191" },
  { code: "CU", value: "CUB", name: "Cuba", number: "192" },
  { code: "CW", value: "CUW", name: "Curaçao", number: "531" },
  { code: "CY", value: "CYP", name: "Cyprus", number: "196" },
  { code: "CZ", value: "CZE", name: "Czechia", number: "203" },
  { code: "CI", value: "CIV", name: "Côte d'Ivoire", number: "384" },
  { code: "DK", value: "DNK", name: "Denmark", number: "208" },
  { code: "DJ", value: "DJI", name: "Djibouti", number: "262" },
  { code: "DM", value: "DMA", name: "Dominica", number: "212" },
  { code: "DO", value: "DOM", name: "Dominican Republic (the)", number: "214" },
  { code: "EC", value: "ECU", name: "Ecuador", number: "218" },
  { code: "EG", value: "EGY", name: "Egypt", number: "818" },
  { code: "SV", value: "SLV", name: "El Salvador", number: "222" },
  { code: "GQ", value: "GNQ", name: "Equatorial Guinea", number: "226" },
  { code: "ER", value: "ERI", name: "Eritrea", number: "232" },
  { code: "EE", value: "EST", name: "Estonia", number: "233" },
  { code: "SZ", value: "SWZ", name: "Eswatini", number: "748" },
  { code: "ET", value: "ETH", name: "Ethiopia", number: "231" },
  {
    code: "FK",
    value: "FLK",
    name: "Falkland Islands (the) [Malvinas]",
    number: "238",
  },
  { code: "FO", value: "FRO", name: "Faroe Islands (the)", number: "234" },
  { code: "FJ", value: "FJI", name: "Fiji", number: "242" },
  { code: "FI", value: "FIN", name: "Finland", number: "246" },
  { code: "FR", value: "FRA", name: "France", number: "250" },
  { code: "GF", value: "GUF", name: "French Guiana", number: "254" },
  { code: "PF", value: "PYF", name: "French Polynesia", number: "258" },
  {
    code: "TF",
    value: "ATF",
    name: "French Southern Territories (the)",
    number: "260",
  },
  { code: "GA", value: "GAB", name: "Gabon", number: "266" },
  { code: "GM", value: "GMB", name: "Gambia (the)", number: "270" },
  { code: "GE", value: "GEO", name: "Georgia", number: "268" },
  { code: "DE", value: "DEU", name: "Germany", number: "276" },
  { code: "GH", value: "GHA", name: "Ghana", number: "288" },
  { code: "GI", value: "GIB", name: "Gibraltar", number: "292" },
  { code: "GR", value: "GRC", name: "Greece", number: "300" },
  { code: "GL", value: "GRL", name: "Greenland", number: "304" },
  { code: "GD", value: "GRD", name: "Grenada", number: "308" },
  { code: "GP", value: "GLP", name: "Guadeloupe", number: "312" },
  { code: "GU", value: "GUM", name: "Guam", number: "316" },
  { code: "GT", value: "GTM", name: "Guatemala", number: "320" },
  { code: "GG", value: "GGY", name: "Guernsey", number: "831" },
  { code: "GN", value: "GIN", name: "Guinea", number: "324" },
  { code: "GW", value: "GNB", name: "Guinea-Bissau", number: "624" },
  { code: "GY", value: "GUY", name: "Guyana", number: "328" },
  { code: "HT", value: "HTI", name: "Haiti", number: "332" },
  {
    code: "HM",
    value: "HMD",
    name: "Heard Island and McDonald Islands",
    number: "334",
  },
  { code: "VA", value: "VAT", name: "Holy See (the)", number: "336" },
  { code: "HN", value: "HND", name: "Honduras", number: "340" },
  { code: "HK", value: "HKG", name: "Hong Kong", number: "344" },
  { code: "HU", value: "HUN", name: "Hungary", number: "348" },
  { code: "IS", value: "ISL", name: "Iceland", number: "352" },
  { code: "IN", value: "IND", name: "India", number: "356" },
  { code: "ID", value: "IDN", name: "Indonesia", number: "360" },
  {
    code: "IR",
    value: "IRN",
    name: "Iran (Islamic Republic of)",
    number: "364",
  },
  { code: "IQ", value: "IRQ", name: "Iraq", number: "368" },
  { code: "IE", value: "IRL", name: "Ireland", number: "372" },
  { code: "IM", value: "IMN", name: "Isle of Man", number: "833" },
  { code: "IL", value: "ISR", name: "Israel", number: "376" },
  { code: "IT", value: "ITA", name: "Italy", number: "380" },
  { code: "JM", value: "JAM", name: "Jamaica", number: "388" },
  { code: "JP", value: "JPN", name: "Japan", number: "392" },
  { code: "JE", value: "JEY", name: "Jersey", number: "832" },
  { code: "JO", value: "JOR", name: "Jordan", number: "400" },
  { code: "KZ", value: "KAZ", name: "Kazakhstan", number: "398" },
  { code: "KE", value: "KEN", name: "Kenya", number: "404" },
  { code: "KI", value: "KIR", name: "Kiribati", number: "296" },
  {
    code: "KP",
    value: "PRK",
    name: "Korea (the Democratic People's Republic of)",
    number: "408",
  },
  { code: "KR", value: "KOR", name: "Korea (the Republic of)", number: "410" },
  { code: "KW", value: "KWT", name: "Kuwait", number: "414" },
  { code: "KG", value: "KGZ", name: "Kyrgyzstan", number: "417" },
  {
    code: "LA",
    value: "LAO",
    name: "Lao People's Democratic Republic (the)",
    number: "418",
  },
  { code: "LV", value: "LVA", name: "Latvia", number: "428" },
  { code: "LB", value: "LBN", name: "Lebanon", number: "422" },
  { code: "LS", value: "LSO", name: "Lesotho", number: "426" },
  { code: "LR", value: "LBR", name: "Liberia", number: "430" },
  { code: "LY", value: "LBY", name: "Libya", number: "434" },
  { code: "LI", value: "LIE", name: "Liechtenstein", number: "438" },
  { code: "LT", value: "LTU", name: "Lithuania", number: "440" },
  { code: "LU", value: "LUX", name: "Luxembourg", number: "442" },
  { code: "MO", value: "MAC", name: "Macao", number: "446" },
  { code: "MG", value: "MDG", name: "Madagascar", number: "450" },
  { code: "MW", value: "MWI", name: "Malawi", number: "454" },
  { code: "MY", value: "MYS", name: "Malaysia", number: "458" },
  { code: "MV", value: "MDV", name: "Maldives", number: "462" },
  { code: "ML", value: "MLI", name: "Mali", number: "466" },
  { code: "MT", value: "MLT", name: "Malta", number: "470" },
  { code: "MH", value: "MHL", name: "Marshall Islands (the)", number: "584" },
  { code: "MQ", value: "MTQ", name: "Martinique", number: "474" },
  { code: "MR", value: "MRT", name: "Mauritania", number: "478" },
  { code: "MU", value: "MUS", name: "Mauritius", number: "480" },
  { code: "YT", value: "MYT", name: "Mayotte", number: "175" },
  { code: "MX", value: "MEX", name: "Mexico", number: "484" },
  {
    code: "FM",
    value: "FSM",
    name: "Micronesia (Federated States of)",
    number: "583",
  },
  {
    code: "MD",
    value: "MDA",
    name: "Moldova (the Republic of)",
    number: "498",
  },
  { code: "MC", value: "MCO", name: "Monaco", number: "492" },
  { code: "MN", value: "MNG", name: "Mongolia", number: "496" },
  { code: "ME", value: "MNE", name: "Montenegro", number: "499" },
  { code: "MS", value: "MSR", name: "Montserrat", number: "500" },
  { code: "MA", value: "MAR", name: "Morocco", number: "504" },
  { code: "MZ", value: "MOZ", name: "Mozambique", number: "508" },
  { code: "MM", value: "MMR", name: "Myanmar", number: "104" },
  { code: "NA", value: "NAM", name: "Namibia", number: "516" },
  { code: "NR", value: "NRU", name: "Nauru", number: "520" },
  { code: "NP", value: "NPL", name: "Nepal", number: "524" },
  { code: "NL", value: "NLD", name: "Netherlands (the)", number: "528" },
  { code: "NC", value: "NCL", name: "New Caledonia", number: "540" },
  { code: "NZ", value: "NZL", name: "New Zealand", number: "554" },
  { code: "NI", value: "NIC", name: "Nicaragua", number: "558" },
  { code: "NE", value: "NER", name: "Niger (the)", number: "562" },
  { code: "NG", value: "NGA", name: "Nigeria", number: "566" },
  { code: "NU", value: "NIU", name: "Niue", number: "570" },
  { code: "NF", value: "NFK", name: "Norfolk Island", number: "574" },
  {
    code: "MP",
    value: "MNP",
    name: "Northern Mariana Islands (the)",
    number: "580",
  },
  { code: "NO", value: "NOR", name: "Norway", number: "578" },
  { code: "OM", value: "OMN", name: "Oman", number: "512" },
  { code: "PK", value: "PAK", name: "Pakistan", number: "586" },
  { code: "PW", value: "PLW", name: "Palau", number: "585" },
  { code: "PS", value: "PSE", name: "Palestine, State of", number: "275" },
  { code: "PA", value: "PAN", name: "Panama", number: "591" },
  { code: "PG", value: "PNG", name: "Papua New Guinea", number: "598" },
  { code: "PY", value: "PRY", name: "Paraguay", number: "600" },
  { code: "PE", value: "PER", name: "Peru", number: "604" },
  { code: "PH", value: "PHL", name: "Philippines (the)", number: "608" },
  { code: "PN", value: "PCN", name: "Pitcairn", number: "612" },
  { code: "PL", value: "POL", name: "Poland", number: "616" },
  { code: "PT", value: "PRT", name: "Portugal", number: "620" },
  { code: "PR", value: "PRI", name: "Puerto Rico", number: "630" },
  { code: "QA", value: "QAT", name: "Qatar", number: "634" },
  {
    code: "MK",
    value: "MKD",
    name: "Republic of North Macedonia",
    number: "807",
  },
  { code: "RO", value: "ROU", name: "Romania", number: "642" },
  { code: "RU", value: "RUS", name: "Russian Federation (the)", number: "643" },
  { code: "RW", value: "RWA", name: "Rwanda", number: "646" },
  { code: "RE", value: "REU", name: "Réunion", number: "638" },
  { code: "BL", value: "BLM", name: "Saint Barthélemy", number: "652" },
  {
    code: "SH",
    value: "SHN",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    number: "654",
  },
  { code: "KN", value: "KNA", name: "Saint Kitts and Nevis", number: "659" },
  { code: "LC", value: "LCA", name: "Saint Lucia", number: "662" },
  {
    code: "MF",
    value: "MAF",
    name: "Saint Martin (French part)",
    number: "663",
  },
  {
    code: "PM",
    value: "SPM",
    name: "Saint Pierre and Miquelon",
    number: "666",
  },
  {
    code: "VC",
    value: "VCT",
    name: "Saint Vincent and the Grenadines",
    number: "670",
  },
  { code: "WS", value: "WSM", name: "Samoa", number: "882" },
  { code: "SM", value: "SMR", name: "San Marino", number: "674" },
  { code: "ST", value: "STP", name: "Sao Tome and Principe", number: "678" },
  { code: "SA", value: "SAU", name: "Saudi Arabia", number: "682" },
  { code: "SN", value: "SEN", name: "Senegal", number: "686" },
  { code: "RS", value: "SRB", name: "Serbia", number: "688" },
  { code: "SC", value: "SYC", name: "Seychelles", number: "690" },
  { code: "SL", value: "SLE", name: "Sierra Leone", number: "694" },
  { code: "SG", value: "SGP", name: "Singapore", number: "702" },
  {
    code: "SX",
    value: "SXM",
    name: "Sint Maarten (Dutch part)",
    number: "534",
  },
  { code: "SK", value: "SVK", name: "Slovakia", number: "703" },
  { code: "SI", value: "SVN", name: "Slovenia", number: "705" },
  { code: "SB", value: "SLB", name: "Solomon Islands", number: "090" },
  { code: "SO", value: "SOM", name: "Somalia", number: "706" },
  { code: "ZA", value: "ZAF", name: "South Africa", number: "710" },
  {
    code: "GS",
    value: "SGS",
    name: "South Georgia and the South Sandwich Islands",
    number: "239",
  },
  { code: "SS", value: "SSD", name: "South Sudan", number: "728" },
  { code: "ES", value: "ESP", name: "Spain", number: "724" },
  { code: "LK", value: "LKA", name: "Sri Lanka", number: "144" },
  { code: "SD", value: "SDN", name: "Sudan (the)", number: "729" },
  { code: "SR", value: "SUR", name: "Suriname", number: "740" },
  { code: "SJ", value: "SJM", name: "Svalbard and Jan Mayen", number: "744" },
  { code: "SE", value: "SWE", name: "Sweden", number: "752" },
  { code: "CH", value: "CHE", name: "Switzerland", number: "756" },
  { code: "SY", value: "SYR", name: "Syrian Arab Republic", number: "760" },
  { code: "TW", value: "TWN", name: "Taiwan", number: "158" },
  { code: "TJ", value: "TJK", name: "Tajikistan", number: "762" },
  {
    code: "TZ",
    value: "TZA",
    name: "Tanzania, United Republic of",
    number: "834",
  },
  { code: "TH", value: "THA", name: "Thailand", number: "764" },
  { code: "TL", value: "TLS", name: "Timor-Leste", number: "626" },
  { code: "TG", value: "TGO", name: "Togo", number: "768" },
  { code: "TK", value: "TKL", name: "Tokelau", number: "772" },
  { code: "TO", value: "TON", name: "Tonga", number: "776" },
  { code: "TT", value: "TTO", name: "Trinidad and Tobago", number: "780" },
  { code: "TN", value: "TUN", name: "Tunisia", number: "788" },
  { code: "TR", value: "TUR", name: "Turkey", number: "792" },
  { code: "TM", value: "TKM", name: "Turkmenistan", number: "795" },
  {
    code: "TC",
    value: "TCA",
    name: "Turks and Caicos Islands (the)",
    number: "796",
  },
  { code: "TV", value: "TUV", name: "Tuvalu", number: "798" },
  { code: "UG", value: "UGA", name: "Uganda", number: "800" },
  { code: "UA", value: "UKR", name: "Ukraine", number: "804" },
  {
    code: "AE",
    value: "ARE",
    name: "United Arab Emirates (the)",
    number: "784",
  },
  {
    code: "GB",
    value: "GBR",
    name: "United Kingdom of Great Britain and Northern Ireland (the)",
    number: "826",
  },
  {
    code: "UM",
    value: "UMI",
    name: "United States Minor Outlying Islands (the)",
    number: "581",
  },
  {
    code: "US",
    value: "USA",
    name: "United States of America",
    number: "840",
  },
  { code: "UY", value: "URY", name: "Uruguay", number: "858" },
  { code: "UZ", value: "UZB", name: "Uzbekistan", number: "860" },
  { code: "VU", value: "VUT", name: "Vanuatu", number: "548" },
  {
    code: "VE",
    value: "VEN",
    name: "Venezuela",
    number: "862",
  },
  { code: "VN", value: "VNM", name: "Viet Nam", number: "704" },
  { code: "VG", value: "VGB", name: "Virgin Islands (British)", number: "092" },
  { code: "VI", value: "VIR", name: "Virgin Islands (U.S.)", number: "850" },
  { code: "WF", value: "WLF", name: "Wallis and Futuna", number: "876" },
  { code: "EH", value: "ESH", name: "Western Sahara", number: "732" },
  { code: "YE", value: "YEM", name: "Yemen", number: "887" },
  { code: "ZM", value: "ZMB", name: "Zambia", number: "894" },
  { code: "ZW", value: "ZWE", name: "Zimbabwe", number: "716" },
  { code: "AX", value: "ALA", name: "Åland Islands", number: "248" },
];
